import svgConnect from "../../../../assets/imgs/socials/connects/reddit.svg";
import svgNaoConectado from "../../../../assets/imgs/socials/notConnects/reddit.svg";

import MyImage from "../../../myImage"

const MyIconReddit = ({sx, connect}) =><MyImage src={connect ? svgConnect : svgNaoConectado} alt={'reddit icon'} sx={sx} />

export default MyIconReddit;
